let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6hula")).then(() => parcelRequire('5lVtr'));